"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var classnames_1 = __importDefault(require("classnames"));
var SCALE_FACTOR = 1.35;
var HEIGHT = 120;
function CarrosselExplosivo(_a) {
  var children = _a.children,
    indiceDoDestacado = _a.indiceDoDestacado,
    aoMudarDeFoco = _a.aoMudarDeFoco;
  return react_1.default.createElement(rebass_1.Box, {
    sx: {
      width: "100%",
      overflowX: "scroll",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      minHeight: HEIGHT * SCALE_FACTOR
    }
  }, react_1.default.createElement(rebass_1.Box, {
    sx: {
      height: "100%",
      display: "flex",
      flexWrap: ["nowrap", "wrap"],
      alignItems: "center"
    }
  }, children.map(function (child, index) {
    return react_1.default.createElement(rebass_1.Box, {
      key: index,
      onClickCapture: function (e) {
        var _a;
        if ((_a = e.target) === null || _a === void 0 ? void 0 : _a.scrollIntoView) e.target.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      },
      sx: {
        flexShrink: 0,
        cursor: "pointer",
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        margin: 15,
        justifyContent: "center",
        background: "#fff",
        height: HEIGHT,
        width: HEIGHT,
        boxShadow: "0px 6px 8px #0D0D361A",
        transition: "ease 0.3s transform",
        "&.ativo": {
          transform: "scale(1.25)"
        },
        "&.inativo": {
          transform: "scale(0.8)"
        }
      },
      onClick: function () {
        return aoMudarDeFoco(index);
      },
      className: classnames_1.default({
        ativo: index === indiceDoDestacado,
        inativo: index !== indiceDoDestacado
      })
    }, react_1.default.createElement(rebass_1.Flex, {
      className: classnames_1.default({
        inativo: index !== indiceDoDestacado
      }),
      "data-testid": "item-" + index,
      sx: {
        justifyContent: "center",
        alignItems: "center",
        svg: {
          width: "70%",
          maxHeight: HEIGHT * 0.7
        },
        "&.inativo": {
          svg: {
            path: {
              fill: "#B5B5B5"
            }
          }
        }
      }
    }, child));
  })));
}
exports.default = CarrosselExplosivo;